import { LAYOUTS } from "@voltmoney/types";
import { ROUTE } from "../../../routes";
import { WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { goBack } from "./action";
import { getContactUsDetails } from "../../../configs/utils";
import SharedPropsService from "../../../SharedPropsService";
export const template = (height, contactUsDetails, pledgedData, fundValue) => ({
    layout: {
        id: ROUTE.FORECLOSURE_COLLATERAL_DETAILS,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: "foreclosureCollateralsDetails",
                type: WIDGET.FORECLOSURE_COLLATERAL_DETAILS,
            },
        ],
    },
    datastore: {
        foreclosureCollateralsDetails: {
            height,
            contactUsDetails,
            pledgedData,
            fundValue,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.FORECLOSURE_COLLATERAL_DETAILS,
            },
        },
    },
});
export const foreclosureCollateralsDetailsMf = {
    onLoad: async ({ getHeight }, { creditData }) => {
        const user = await SharedPropsService.getUser();
        const fundValue = user?.linkedCredits[0]?.totalValueOfAssetsPledged;
        const contactUsDetails = await getContactUsDetails();
        const pledgedData = creditData;
        return Promise.resolve(template(getHeight(), contactUsDetails, pledgedData, fundValue));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
    },
};
